/**
 * One header for every Home section — Open findings, Coming up: the title
 * at 13px medium, a muted count, an optional aside at the end, and a hairline
 * under it.
 *
 * @module components/home/HomeSectionHeader
 */
import type { ReactNode } from "react";

export function HomeSectionHeader({
  title,
  count,
  aside,
}: {
  readonly title: string;
  readonly count?: number | undefined;
  readonly aside?: ReactNode;
}) {
  return (
    <div className="mb-1 flex min-h-7 items-center gap-2 border-b border-border/60 pb-1.5" data-home-section-header="">
      <h2 className="flex min-w-0 items-center gap-2">
        <span className="text-[13px] font-medium text-foreground">{title}</span>
        {count !== undefined ? (
          <span className="text-xs tabular-nums text-muted-foreground/70">{count}</span>
        ) : null}
      </h2>
      {aside ? <div className="ms-auto shrink-0">{aside}</div> : null}
    </div>
  );
}
